import { getSeatSelectionRulesForState } from './get-seat-selection-rules-for-state';
export function validateSeatingDataAgainstSeatSelectionRules(rules, data, selectedSeats) {
    const rulesToEvaluate = getSeatSelectionRulesForState(rules, data, selectedSeats);
    const validationResults = rulesToEvaluate.map(rule => rule.validate(data, selectedSeats));
    const violatedRules = validationResults.filter(result => !result.isValid);
    return {
        isValid: violatedRules.length === 0,
        violatedRules: violatedRules.map(result => result.ruleName)
    };
}
